(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pauseForReducedMotion = () => {
    if (!reduceMotion.matches) return;

    document.querySelectorAll('.ti-hero-carousel').forEach((carousel) => {
      if (typeof carousel.pause !== 'function') return;

      carousel.pause();

      if (carousel.sliderAutoplayButton && typeof carousel.togglePlayButtonState === 'function') {
        carousel.togglePlayButtonState(true);
        carousel.autoplayButtonIsSetToPlay = false;
      }
    });
  };

  customElements.whenDefined('slideshow-component').then(() => {
    requestAnimationFrame(pauseForReducedMotion);
  });

  reduceMotion.addEventListener('change', pauseForReducedMotion);
})();
